import React from 'react'
import createIcon from '@/lib/create-icon'

export const BookSVGIcon = createIcon(
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.6665 13C2.6665 12.558 2.8421 12.134 3.15466 11.8215C3.46722 11.5089 3.89114 11.3333 4.33317 11.3333H13.3332M2.6665 13C2.6665 13.442 2.8421 13.8659 3.15466 14.1785C3.46722 14.4911 3.89114 14.6666 4.33317 14.6666H13.3332V1.33331H4.33317C3.89114 1.33331 3.46722 1.50891 3.15466 1.82147C2.8421 2.13403 2.6665 2.55795 2.6665 2.99998V13Z"
      stroke="#0B947C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
)
